import { useState, useEffect } from 'react';
import { useTestContext } from '../../../context/testContext';
import { useCalibration } from '../../../context/calibrationContext';
import { Flex, Text } from '../../../2022-component-library';
import { PatientFacialDetection } from '../../../components';
import { useReceiveMessage } from '../../../context/messageContext';

const ResponsiveContrastSensitivityTestPatient = () => {
  const { testData, updateTestData } = useTestContext();
  const { calibrationData } = useCalibration();
  const [logmarData, setLogmarData] = useState({});
  const messageFromOptician = useReceiveMessage();
  const [testMode, setTestMode] = useState('');

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'updateContrastSensitivityContent':
        const { backgroundColor, fontColor, characters } = messageFromOptician.content;
        setLogmarData({ ...logmarData, backgroundColor: backgroundColor, fontColor: fontColor, characters: characters });
        updateTestData({ backgroundColor: backgroundColor, fontColor: fontColor, characters: characters });
        break;
      case 'contrastSensitivity':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceFromScreen,
          backgroundColor: messageFromOptician.content.backgroundColor,
          fontColor: messageFromOptician.content.fontColor,
          characters: messageFromOptician.content.characters,
          methodSelected: messageFromOptician.content.methodSelected,
        });
        updateTestData({ methodSelected: messageFromOptician.content.methodSelected });
        if (calibrationData.methodSelected !== 'manual') {
          updateTestData({ testMode: 'auto' });
        } else {
          updateTestData({ testMode: messageFromOptician.content.testMode });
        }
        break;
      case 'resizeLogmar':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          characters: messageFromOptician.content.logmarCharacters,
          fontColor: messageFromOptician.content.fontColor,
        });
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  useEffect(() => {
    setTestMode(testData.testMode);
  }, [testData.testMode]);

  return (
    <Flex>
      <PatientFacialDetection testMode={testMode} />
      <Flex width='100vw' height='100vh' centered zIndex='9'>
        <Text color={logmarData?.fontColor} fontFamily='OpticianSans' fontSize={`${logmarData?.size}px`}>
          {logmarData?.characters}
        </Text>
      </Flex>
    </Flex>
  );
};
export default ResponsiveContrastSensitivityTestPatient;
